import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IMyDpOptions } from 'mydatepicker';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { FeatureClass } from '../Classes/FeatureConfigurationClass';
import { OrganizationService } from '../Services/OrganizationService';
import { NgForm } from '@angular/forms';


@Component({
  selector: 'FeatureConfiguration',
  templateUrl: '../Organization/FeatureConfiguration.Component.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css', '../../Content/css/jquery.dropdownReplacement.css', '../../Content/css/fixedheader.css',
    '../../Content/css/jquery.dropdownReplacementhotel.css'],
  providers: [OrganizationService]
})

export class FeatureConfigurationComponent implements OnInit {
  _FeatureConfig = new FeatureClass();
  TenantID: string;
  innerWidth: number;
  loading: boolean = false;
  Loaderimage: string = '../../assets/images/ajax-loader3.gif';
  isValidFormSubmitted = false;
  InvoiceEntryNotification: any[];
  SubModuleMasterArray: any[];
  ModuleMasterArray: any[];
  CheckboxList: any[] = []
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    height: '20px',
    width: '83%',
    selectionTxtFontSize: '12px',
    inline: false,
    //markDates: [color: 'green'],
    selectorHeight: '218px',
    selectorWidth: '247px',
    openSelectorOnInputClick: true
  };

  constructor(private router: Router, private Activeroute: ActivatedRoute, public toastr: ToastsManager, vcr: ViewContainerRef,
    private _OrganizationSer: OrganizationService) {
    this.toastr.setRootViewContainerRef(vcr);
    this.innerWidth = 100;
    this.GetAllMasterdata();
  }

  ngOnInit() {
    this.ChangeHeadeFooterColor();
    if (this.Activeroute.snapshot.params['TenantID'] != null) {
      this.TenantID = JSON.parse(atob(this.Activeroute.snapshot.params['TenantID']));
      var PageName = JSON.parse(atob(this.Activeroute.snapshot.params['pageName']));
     
      this.GetInvoiceEntryNotification(this.TenantID);
      this.GetAllFeatureConfig(this.TenantID);
      localStorage.setItem("TenantID", this.TenantID);
    }
  }

  public GetAllFeatureConfig(TenantID: string) {
    this.loading = true;
    this._OrganizationSer.GetAllFeatureConfig(TenantID).subscribe(res => {
      var data = res;
      if (data == "" || data == null) {
        this.DefaultValuesPermission(Number(TenantID));
      }
      else {
        this.FillRecordFeature(data);
        this.GetAllSubModuleMaster(data[0].TenantId);
        this.GetAllModuleMaster(data[0].TenantId);
      }
      this.loading = false;
    });
  }

  get_url: string = '';
  public ChangeHeadeFooterColor() {

    this.get_url = window.location.origin;
    if (this.get_url == "https://localhost:44335") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

      // var mnu_Reports = document.getElementsByTagName("ul[_ngcontent-c2] li[_ngcontent-c2]");


    }
    else if (this.get_url == "https://inn-flowmgt-test.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

    }
    else if (this.get_url == "https://inn-flowmgt-staging.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#ed7d31";

      var footer = document.getElementById("footer");
      footer.style.background = "#ed7d31";

      var header = document.getElementById("header");
      header.style.background = "#ed7d31";
    }
  }

  public GetAllMasterdata() {
    this.loading = true;
    this._OrganizationSer.GetAllMasterdata().subscribe(res => {
      var data = res;
      this.CheckboxList = data;
      console.log(this.CheckboxList);
      this.loading = false;
    });
  }

  public GetInvoiceEntryNotification(TenantID: string) {
    this.loading = true;
    this._OrganizationSer.GetInvoiceEntryNotification(TenantID).subscribe(res => {
      var data = res;
      this.InvoiceEntryNotification = data;
      this.loading = false;
    });
  }

  public SaveFeatureConfig(form: NgForm) {
    if (form.valid) {
      if (!this.IsItDecimal(this._FeatureConfig.DocumentLibrary)) {
        this.toastr.error('Enter valid file size limit.');
        return;
      }
      if (!this.IsItDecimal(this._FeatureConfig.DailyActivity)) {
        this.toastr.error('Enter valid file size limit.');
        return;
      }
      if (!this.IsItDecimal(this._FeatureConfig.AllOtherFile)) {
        this.toastr.error('Enter valid file size limit.');
        return;
      }
      if (!this.IsItDecimal(this._FeatureConfig.PayrollVariance)) {
        this.toastr.error('Enter valid file size limit.');
        return;
      }
      this._FeatureConfig.ReviewDate = !this._FeatureConfig.ReviewDate ? "" : this._FeatureConfig.ReviewDate;
      if (this.CheckReviewDateFormat(this._FeatureConfig.ReviewDate) == true) {
        this.loading = true;
        this._FeatureConfig.UsernameAutoCreate = this._FeatureConfig.UsernameAutocreate == true ? 'True' : 'False';
        this._FeatureConfig.ReviewStartDate = formatDate(this._FeatureConfig.ReviewStartDate.jsdate);
        this._FeatureConfig.EHIDPermission = true;
        this._OrganizationSer.SaveFeatureConfigDetails(this._FeatureConfig).subscribe(res => {
          var data = res;
          if (data.message == "Record Saved Successfully" || data.message == "Updated Successfully") {
            this.toastr.success(data.message);
            this._FeatureConfig.CheckBoxListArray = [];
            this.GetAllFeatureConfig(data.tenantId);
          }
          else { this.toastr.error(data.message); };
          this.loading = false;
        })
      }
    }
    else {
      this.isValidFormSubmitted = true;
    }
  }

  public DefaultValuesPermission(TenantID: number) {
    this._FeatureConfig.TenantId = TenantID;
    this._FeatureConfig.DocumentLibrary = '5.00';
    this._FeatureConfig.DailyActivity = '10.00';
    this._FeatureConfig.AllOtherFile = '5.00';
    this._FeatureConfig.PayrollVariance = '0.03';
    this._FeatureConfig.PayrollAutoTransfer = true;
    this._FeatureConfig.UsernameAutocreate = true;
    this._FeatureConfig.Enterprisesetting = '1';
    this._FeatureConfig.ReviewStartDate = { jsdate: new Date() };
    this._FeatureConfig.ReviewDate = '';
    this._FeatureConfig.Operatingstatmentreport = '0';
    this._FeatureConfig.EHIDPermission = true;
    this._FeatureConfig.EmpCodeForADP = false;
    this._FeatureConfig.CheckPrintsplit = true;
    this._FeatureConfig.CheckfromEnterprise = true;
    this._FeatureConfig.PrintSeparatecheck = false;
    this._FeatureConfig.InvoiceApprovalorder = 'Vendor';
    this._FeatureConfig.MinusOOO = false;
    this._FeatureConfig.DuplicateInvoiceNumber = '30';
    this._FeatureConfig.InvoiceReadyforEntry = '-1';
    this._FeatureConfig.transactionsEHID = false;
    this._FeatureConfig.Automaticallycurrentaccountingperiod = true;
    this._FeatureConfig.DigitalSignature = false;
    this.AddAllSubModuleName();
  }

  public FillRecordFeature(data: any) {
    this._FeatureConfig.TenantId = data[0].TenantId;
    this._FeatureConfig.DocumentLibrary = data[0].DocFileSize.toFixed(2);
    this._FeatureConfig.DailyActivity = data[0].DailyEntryFileSize.toFixed(2);
    this._FeatureConfig.AllOtherFile = data[0].FileSizelimit.toFixed(2);
    this._FeatureConfig.PayrollVariance = data[0].PayrollVariance.toFixed(2);
    this._FeatureConfig.PayrollAutoTransfer = data[0].AutoTransfer == "Yes" ? true : false;
    this._FeatureConfig.UsernameAutocreate = data[0].AutoUser == "True" ? true : false;
    this._FeatureConfig.Enterprisesetting = data[0].ReviewType;
    this._FeatureConfig.ReviewStartDate = { jsdate: new Date(data[0].ReviewStartDate) };
    this._FeatureConfig.ReviewDate = data[0].ReviewDate;
    this._FeatureConfig.Operatingstatmentreport = data[0].RptFormat;
    this._FeatureConfig.EHIDPermission = data[0].UserHidPermission == "Yes" ? true : false;
    this._FeatureConfig.EmpCodeForADP = data[0].EmpCodeAdp == "Yes" ? true : false;
    this._FeatureConfig.CheckPrintsplit = data[0].CheckPrintType == "1" ? true : false;
    this._FeatureConfig.CheckfromEnterprise = data[0].ReimburseCheckPrint == "Yes" ? true : false;
    this._FeatureConfig.PrintSeparatecheck = data[0].PrintCheckContract == "Yes" ? true : false;
    this._FeatureConfig.InvoiceApprovalorder = data[0].InvApOrder == null ? "Vendor" : data[0].InvApOrder;
    this._FeatureConfig.MinusOOO = data[0].OutOfOrder == "Yes" ? true : false;
    this._FeatureConfig.DuplicateInvoiceNumber = data[0].AlertRange;
    this._FeatureConfig.InvoiceReadyforEntry = data[0].Notification;
    this._FeatureConfig.transactionsEHID = data[0].IsPostEhid == "Yes" ? true : false;
    this._FeatureConfig.Automaticallycurrentaccountingperiod = data[0].AutoActivate == "false" ? false : true;
    this._FeatureConfig.DigitalSignature = data[0].DigitalSign == "Yes" ? true : false;
    /* new Colum */
    this._FeatureConfig.TimeSheet = data[0].TimeSheet == "true" ? true : false;
    this._FeatureConfig.PTORequest = data[0].PTORequest == "true" ? true : false;
    
  }

  public singleselect(Value: any, event: any) {
    for (var i = 0; i < this._FeatureConfig.CheckBoxListArray.length; i++) {
      if (this._FeatureConfig.CheckBoxListArray[i].Value == Value) {
        if (event.target.checked == true) {
          this._FeatureConfig.CheckBoxListArray[i].checked = true;
        }
        else {
          this._FeatureConfig.CheckBoxListArray[i].checked = false;
        }
      }
    }
  }

  public CancelFeatureConfig() {
    this.router.navigate(['/OrganizationDetails', { TenantID: btoa(JSON.stringify(this.TenantID)), pageName: btoa(JSON.stringify('Feature Configurations')) }]);
  }

  /****************All Sub Module Values Code Start *********************/
  public AddAllSubModuleName() {
    for (var i = 0; i < this.CheckboxList.length; i++) {
      if (this.CheckboxList[i].value == "DepositAudit" || this.CheckboxList[i].value == "UploadDoc" || this.CheckboxList[i].value == "CreditCardDisputes"
        || this.CheckboxList[i].value == "Project Budget" || this.CheckboxList[i].value == "Dashboard") {
        this.CheckboxList[i].checked = true;
        this._FeatureConfig.CheckBoxListArray.push(this.CheckboxList[i]);
      }
      else {
        this.CheckboxList[i].checked = false;
        this._FeatureConfig.CheckBoxListArray.push(this.CheckboxList[i]);
      }
    }
  }

  public GetAllSubModuleMaster(TenantID: string) {
    this.loading = true;
    this._OrganizationSer.GetAllSubModuleMaster(TenantID).subscribe(res => {
      var data = res;
      if (data != null) {
        this.SubModuleMasterArray = data;
        this.EditSubModuleName();
      }
      else {
        this.toastr.error(data);
      }
      this.loading = false;
    });
  }

  public GetAllModuleMaster(TenantID: string) {
    this.loading = true;
    this._OrganizationSer.GetAllModuleMaster(TenantID).subscribe(res => {
      var data = res;
      if (data != null) {
        this.ModuleMasterArray = data;
        this.EditModuleMaster();
      }
      else {
        this.toastr.error(data);
      }
      this.loading = false;
    });
  }

  public EditSubModuleName() {
    for (var i = 0; i < this.SubModuleMasterArray.length; i++) {
      for (var m = 0; m < this.CheckboxList.length; m++) {
        if (this.CheckboxList[m].value == this.SubModuleMasterArray[i].SubModuleValue) {
          if (this.SubModuleMasterArray[i].Status == "Yes") {
            this.CheckboxList[m].checked = true;
            this._FeatureConfig.CheckBoxListArray.push(this.CheckboxList[m]);
          }
          else {
            this.CheckboxList[m].checked = false;
            this._FeatureConfig.CheckBoxListArray.push(this.CheckboxList[m]);
          }
        }
      }
    }
  }

  public EditModuleMaster() {
    for (var m = 0; m < this.CheckboxList.length; m++) {
      for (var k = 0; k < this.ModuleMasterArray.length; k++) {
        if (this.ModuleMasterArray[k].ModuleValue == this.CheckboxList[m].value) {
          if (this.ModuleMasterArray[k].Status == "Yes") {
            this.CheckboxList[m].checked = true;
            this._FeatureConfig.CheckBoxListArray.push(this.CheckboxList[m]);
          }
          else {
            this.CheckboxList[m].checked = false;
            this._FeatureConfig.CheckBoxListArray.push(this.CheckboxList[m]);
          }
        }

      }
    }
  }
  /****************All Sub Module Values Code End *********************/

  /*-----------------Trim Function-------------------*/
  public trimdata(val: string) {
    if (val != "") {
      return val.toString().trim();
    }
  }
  /*-----------------End Trim Function-------------------*/

  IsItDecimal(val: string) {
    var data = Number(val);
    if (data != 0) {
      if (parseFloat(data.toString())) {
        return true;
      }
      else {
        return false;
      }
    } else { return true; }
  }

  CheckReviewDateFormat(Date: any) {

    if (this._FeatureConfig.Enterprisesetting == '1') {
      if (Date.includes("/") == true) {
        var dateofReview = Date;
        var dob = dateofReview.split('/');
        var mm = dob[0];
        var dd = dob[1];

        if (dd == '' || mm == '' || isNaN(dd) || isNaN(mm) || dd == 0 || mm == 0) {
          this.toastr.error('Specific Date format should be: MM/DD');
          return false;
        }
        else {
          if (dob.length != 2) {
            this.toastr.error('Specific Date format should be: MM/DD');
            return false;
          }
          else {
            if ((mm == 4 || mm == 6 || mm == 9 || mm == 11) && dd > 30) {
              this.toastr.error('Specific Date format should be: MM/DD');
              return false;
            }
            if ((mm == 1 || mm == 3 || mm == 5 || mm == 7 || mm == 8 || mm == 10 || mm == 12) && dd > 31) {
              this.toastr.error('Specific Date format should be: MM/DD');
              return false;
            }
            if (mm == 2) {
              if (dd >= 29) {
                this.toastr.error('Specific Date format should be: MM/DD');
                return false;
              }
            }
            if (parseFloat(dob[0]) > 12) {
              this.toastr.error('Specific Date format should be: MM/DD');
              return false;
            }
          }
        }
      }
      else {
        this.toastr.error('Specific Date format should be: MM/DD');
        return false;
      }
    }
    return true;
  }
}

function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [year, month, day].join('/');
}




// WEBPACK FOOTER //
// ./src/app/Organization/FeatureConfiguration.Component.ts